import { get, post, put } from "../../config/api";
import { SERVER_URL } from "../../config/app.config";

class RepenishmentPlanService {       

    static async getRestaurantData(restaurantId) {
        const url = `/v3/dashboard/restaurant/${restaurantId}`;
        return await get({ url });
    }

    static async getReplenishmentPlans(data, role) {
        let url = SERVER_URL + "/v1/admin/workflow/restaurant/list";
        return await post({ url, data });
    }

    static async fetchUsersToAssign(restaurantId) {
        const url = SERVER_URL + `/v1/admin/assignee/list/${restaurantId}`; 
        return await get({ url });
    }

    static async cancelReplenishmentPlan({ id, status }) {
        const url = SERVER_URL + `/v1/admin/workflow/terminate/${id}?status=${status}`;
        return await put({ url });
    }

    static async createReplenishmentPlan(data) {
        const url = SERVER_URL + `/v1/admin/workflow/create/list`;
        return await post({ url, data });
    }

    static async attachInventoryPlan({ workflowId, planId }) {
        const url = SERVER_URL + `/v1/admin/inventoryPlan/attach/${workflowId}?planId=${planId}`;
        return await post({ url });
    }

    static async updateFillingDetails(data) {
        const url = SERVER_URL + `/v1/admin/workflow/update/fill`;
        return await post({ url, data });
    }

}

export default RepenishmentPlanService;